import * as Yup from "yup";

const phoneRegex = /^(\+\d{1,2}\s?)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{3,4}$/;
const noSpecialCharRegex = /^[A-Za-z0-9 ]*$/;
const alphaNumericWithCommaRegex = /^[A-Za-z0-9, ]*$/;
const alphaNumeric = /^[A-Za-z0-9]*$/;
const notAllowCharacters = /[eE+-]/;

const numberOnlyCheck = (value: number) =>
  value === undefined || !notAllowCharacters.test(value.toString());

const contact = Yup.object().shape(
  {
    First: Yup.string()
      .matches(noSpecialCharRegex, "Please check name entered")
      .required("First name is required"),
    Last: Yup.string()
      .matches(noSpecialCharRegex, "Please check name entered")
      .required("Last name is required"),
    email: Yup.string()
      .required("Email is required")
      .email("Must be a valid email"),
    Mobile: Yup.string()
      .matches(phoneRegex, "Please enter a valid mobile number")
      .required("Mobile number required"),
    Phone: Yup.string()
      .matches(phoneRegex, "Please enter a valid phone number")
      .required("Phone number required"),
  },
  [["Mobile", "Phone"]]
);

const additionalData = Yup.object().shape({
  Tag: Yup.string().required("Tag is required"),
  Value: Yup.string().required("Value is required"),
});

const processor = Yup.object().shape({
  ProcessorName: Yup.string().required("Name is required"),
  MID: Yup.string().required("MID is required"),
  AdditionalData: Yup.array().of(additionalData),
});

const schema = Yup.object().shape({
  attributes: Yup.object({
    Name: Yup.string()
      .matches(noSpecialCharRegex, "Please check name entered")
      .required("Merchant name is required"),
    Address1: Yup.string()
      .matches(alphaNumericWithCommaRegex, "Please check Address entered")
      .required("Address is required"),
    Address2: Yup.string()
      .matches(alphaNumericWithCommaRegex, "Please check Address entered")
      .nullable()
      .notRequired(),
    Suburb: Yup.string()
      .matches(noSpecialCharRegex, "Please check Suburb entered")
      .required("Suburb is required"),
    State: Yup.string().required("State is required"),
    Postcode: Yup.string()
      .required("Postcode is required")
      .matches(/^[0-9]{4}$/, "Postcodes must be exactly 4 digits"),
    MCC: Yup.string().required("Merchant Category Code is required"),
    MID: Yup.string().matches(alphaNumeric, "Please check MID entered").max(10, "MID must be of 10 characters "),
    Contact: Yup.array()
      .of(contact)
      .min(1, "Must have at least a Primary contact")
      .max(4, "Too many contacts"),
    CashOutDailyLimit: Yup.number()
      .positive()
      .min(0, "Must be greater than 0")
      .moreThan(-1, "Negative values not accepted")
      .max(5000, "Maximum value is 5000$")
      .notRequired()
      .test("numberOnly", "Please enter number value only", (value) =>
        numberOnlyCheck(value)
      )
    ,
    Processor: Yup.array().of(processor),
    SurchargePercentage: Yup.array(
      Yup.object()
        .nullable()
        .shape({
          Percentage: Yup.number()
            .nullable()
            .notRequired()
            .min(0)
            .moreThan(-1, "Negative values not accepted")
            // .max(100, "Maximum value is 100%")
            .test("numberOnly", "Please enter number value only", (value) =>
              numberOnlyCheck(value)
            ),
        })
    ),
    FixedSurchargePercentage: Yup.number()
      .nullable()
      .notRequired()
      .min(0)
      .moreThan(-1, "Negative values not accepted")
      // .max(100, "Maximum value is 100%")
      .test("numberOnly", "Please enter number value only", (value) =>
        numberOnlyCheck(value)
      ),
    FixedSurchargeAmount: Yup.number()
      .nullable()
      .notRequired()
      .min(0)
      .moreThan(-1, "Negative values not accepted")
      .test("numberOnly", "Please enter number value only", (value) =>
        numberOnlyCheck(value)
      ),
  }),
});

export default schema;
